<template>
  <div class="relative p-1 mb-1 bg-gray-800 rounded-sm agenda-event hover:ring-2 hover:ring-yellow-500"
    :class="{ 'ring-yellow-500 ring-4': selected, 'ring-4 ring-white': eventStatus === 'LIVE' }">
    <div class="w-1 top-1 bottom-1 rounded-sm absolute text-xs text-black text-center font-bold pt-0.5"
      :class="bgStatusColor(eventStatus)"></div>
    <div class="justify-between mb-1 ml-1 group-header md:flex">
      <!-- EVENT NAME -->
      <div class="flex items-center ml-6 space-x-1 text-sm">
        <span class="" :class="eventStatusTextColorClass">
          <!-- {{event.name}} -->
          <label class="items-center cursor-pointer sm:inline-flex" :for="event.id + 'x'"
            :class="{ 'pointer-events-none': !showCheck }">
            <input type="checkbox" class="mr-2 form-checkbox" v-show="showCheck" :name="event.id + 'x'"
              :checked="getSelectedIndex(event) !== -1">
            <span>{{ event.name }} </span>
          </label>
        </span>
        <span v-for="status in groupStatuses" :key="status" class="inline-block w-3 h-3 ml-1 transform rounded-sm"
          :class="bgStatusColor(status)"></span>
        <div class="ml-3 agenda-day-event-name-description">
          {{ event.description }}
        </div>
        <div v-if="eventProblems.length" class="ml-2 px-1 text-xs font-bold text-red-600 bg-white rounded-sm whitespace-nowrap">
           PROBLEMS: {{ eventProblems.join(', ') }}
        </div>
      </div>
      <!-- EVENT CLIENT/ACCOUNT -->
      <div class="text-xs text-gray-100 ml-6 md:ml-0 py-0.5 px-1 rounded-sm bg-gray-900 flex items-center gap-2">
        <span v-if="event.tags && event.tags.length" class="flex gap-1 mr-2">
           <span v-for="tag in event.tags" :key="tag" class="px-1.5 py-0.5 text-[10px] uppercase bg-blue-900/50 text-blue-200 rounded-xs">
             {{ tag }}
           </span>
        </span>
        <span class="fc-event-account">
          <span v-if="event.commentaryLanguage" class="commentary-language"><i class="fas fa-globe-americas"></i>
            {{ event.commentaryLanguage }}
          </span>
          <span :class="eventStatusTextColorClass">{{ event.account.name }}</span>
          <span class="inline-block w-2 vertical-divinder"></span>
          <span class="fc-event-account-client">{{ event.customer.name }}</span>
        </span>
        <span v-if="isSysAdmin" class="ml-2 text-gray-500 cursor-pointer w-4 h-4 bg-yellow-500 hover:text-white" @click.stop="showDebugModal = true" title="Debug Event"></span>
      </div>
    </div>
    <div class="items-center justify-between ml-1 sm:flex">
      <!-- <img src="https://corsproxy.io/?https://probes.elas.tech/projects/34/apps/125/tasks/7646/thumbs/51507324?ut=1703197927" alt=""> -->
      <div class="w-full ml-6 text-sm text-gray-100 group-details md:flex md:space-x-4" :class="headerColumnClass">
        <div v-for="col in visibleColumnDefs" :key="'i' + col.headerName" :class="'agenda-day-event-' + col.headerName"
          :style="{ width: isMobileOnly ? 'auto' : col.width + 'px' }" class="flex flex-initial">
          <span class="w-20 text-gray-500 agenda-label md:hidden">
            {{ col.headerName }}
          </span>
          <span class="w-12 time" v-if="col.type === 'time'">
            {{ event[col.field] | dateUtc('H:mm') }}
            <span class="block text-xs opacity-50">{{ event[col.field] | dateUtc('DD/MM') }}</span>
          </span>
          <span class="relative group flex md:block md:items-center gap-1 max-w-full" v-if="col.field === 'inputName'">
            <img :src="thumb.data" alt="" class="w-12"  v-if="isSysAdmin || (event.status === 'LIVE')"/>
            <img :src="thumb.data" alt="" class="absolute z-50 hidden w-52 group:hover:block" v-if="isSysAdmin || (event.status === 'LIVE')"/>
            <span v-html="event[col.field]"></span>
            <!-- {{ event.inputOverride && event.inputOverride.name ? '(Override)' : '' }} 
            {{ event.input && event.input.probeTaskId ? event.input.probeTaskId + '-' + event.input.probeProjectId : '(not set)' }}
            {{ event.inputOverride && event.inputOverride.probeTaskId ? event.inputOverride.probeTaskId + '-' + event.inputOverride.probeProjectId : '' }} -->
            <!-- <span :class="[bgInputStatusColor]" v-if="inputAlert.length === 0"
              class="inline-block w-3 h-3 rounded-full">
            </span>
            <span :class="[bgInputStatusColor]" @click="showModal = true" v-if="inputAlert.length > 0"
              class="w-3 h-3 rounded-full text-xs flex items-center text-center justify-center cursor-pointer">
              {{ inputAlert.length }}
            </span> -->
          </span>
          <span class="w-full wrap-break-word other"
            v-if="col.type === 'html' && col.field !== 'output' && col.field !== 'inputName' && col.field !== 'outputUI' && col.field !== 'audioUI'"
            v-html='event[col.field]'>
          </span>
          <span class="w-full wrap-break-word other" v-if="col.type === 'html' && col.field === 'outputUI'"
            v-html='outputUI'>
          </span>
          <pre class="font-sans audio" v-if="!col.type && col.field === 'audioUI'">{{ event[col.field] }}
          </pre>

          <span class="w-full wrap-break-word other" v-if="!col.type && col.field !== 'audioUI'"
            :class="{ warning: event[col.field] === 'not set' }">
            {{ event[col.field] }}
          </span>
        </div>
        <div>
        </div>
      </div>
    </div>

    <!--ACTIONS -->
    <div class="absolute bottom-0 right-0 bg-gray-800 agenda-event-actions">
      <slot></slot>
    </div>

    <!-- DEBUG MODAL -->
    <div v-if="showDebugModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity z-[0]" @click="showDebugModal = false">
          <div class="absolute inset-0 bg-black/50"></div>
        </div>

        <div class="relative z-10 w-full max-w-4xl overflow-hidden text-left align-bottom transition-all transform bg-black rounded-lg shadow-xl sm:my-8 sm:align-middle">
          <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
            <h4 class="mb-4 text-lg font-bold text-gray-900">Event Debug Info</h4>
            <div class="space-y-4 text-sm text-gray-700">
              
              <div>
                <h5 class="font-bold">Input</h5>
                <pre class="p-2 overflow-auto bg-[#13191d] rounded max-h-40">{{ JSON.stringify(event.input, null, 2) }}</pre>
              </div>

              <div>
                <h5 class="font-bold">Outputs</h5>
                <pre class="p-2 overflow-auto bg-[#13191d] rounded max-h-40">{{ JSON.stringify(event.outputs, null, 2) }}</pre>
              </div>

              <div>
                <h5 class="font-bold">Actions</h5>
                <pre class="p-2 overflow-auto bg-[#13191d] rounded max-h-40">{{ JSON.stringify(event.actions, null, 2) }}</pre>
              </div>

               <div>
                <h5 class="font-bold">Full Event</h5>
                <pre class="p-2 overflow-auto bg-[#13191d] rounded max-h-40">{{ JSON.stringify(event, null, 2) }}</pre>
              </div>

            </div>
          </div>
          <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
            <button @click="showDebugModal = false" type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-show="showModal" class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity" @click="showModal = false">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div
          class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">

            <h4 class="font-bold">Alarms</h4>
            <div class="sm:flex sm:items-start">
              <div class="mt-3 text-center sm:mt-0 sm:text-left max-h-[70vh] w-full overflow-y-scroll">
                <ul>
                  <li v-for="(alert, index) in inputAlert" :key="index" class="py-2 border-b border-gray-200">

                    <div class="text-xs">{{ alert.level }} &bull; {{ alert.type }} &bull; {{ new
                      Date(alert.trigger_time).toLocaleString()}}</div>
                    <div>{{ alert.name }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-xs sm:ml-3 sm:w-auto">
              <button @click="showModal = false"
                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md shadow-xs hover:bg-indigo-500 focus:outline-hidden focus:border-indigo-700 focus:shadow-outline-indigo sm:text-sm sm:leading-5">
                Close
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, toRefs } from 'vue'
import moment from 'moment'
import Servers from '../../services/Servers'

const props = defineProps({
  event: {
    type: Object,
    required: true
  },
  groupEventsStatuses: {
    type: Array,
    default: () => []
  },
  visibleColumnDefs: {
    type: Array,
    default: () => []
  },
  isMobileOnly: {
    type: Boolean,
    default: false
  },
  showCheck: {
    type: Boolean,
    default: false
  },
  selectedEvents: {
    type: Array,
    default: () => []
  },
  selected: {
    type: Boolean,
    default: false
  },
  serverStatus: {
    type: Object,
    default: () => ({})
  },
  inputStatuses: {
    type: Object,
    default: () => ({})
  },
  isSysAdmin: {
    type: Boolean,
    default: false
  },
  streamManagerConnections: {
    type: Object,
    default: () => ({})
  }
})

// Reactive data
const showModal = ref(false)
const showDebugModal = ref(false)
const thumb = ref({})
const thumbAll = ref({
  input: {},
  override: {}
})

// Computed properties
const groupStatuses = computed(() => {
  return [...new Set(props.groupEventsStatuses)]
})

const inputThumbData = computed(() => {
  const { input, inputOverride } = props.event
  return input?.probeTaskId + '-' + input?.probeProjectId
})

const thumbData = computed(() => {
  const { input, inputOverride } = props.event
  if (inputOverride && inputOverride.name && inputOverride?.probeProjectId) {
    return props.inputStatuses[inputOverride?.probeProjectId][inputOverride.probeTaskId]?.thumb?.data || {}
  }
  if (input && !input.probeProjectId && props.inputStatuses[input.id] && props.inputStatuses[input.id].thumb) {
    return props.inputStatuses[input.id].thumb.data || {}
  }
  if (!props.inputStatuses || !props.inputStatuses[input?.probeProjectId]) return {}
  return props.inputStatuses[input?.probeProjectId][input?.probeTaskId]?.thumb?.data || {}
})

const inputStatusData = computed(() => {
  const { input, inputOverride } = props.event
  if (inputOverride && inputOverride.name && inputOverride.probeTaskId && props.inputStatuses && props.inputStatuses[input?.probeProjectId] && props.inputStatuses[input.probeProjectId][inputOverride.probeTaskId]) {
    thumb.value = props.inputStatuses[inputOverride?.probeProjectId][inputOverride?.probeTaskId].thumb || {}
    thumbAll.value.override = props.inputStatuses[inputOverride?.probeProjectId][inputOverride?.probeTaskId].thumb || {}
    return thumb.value
  }
  if (input && !input.probeProjectId && props.inputStatuses[input.id]) {
    thumb.value = props.inputStatuses[input.id].thumb || {}
    thumbAll.value.input = props.inputStatuses[input.id].thumb || {}
    return props.inputStatuses[input.id] || {}
  }
  if (!props.inputStatuses || !input || !props.inputStatuses || !props.inputStatuses[input?.probeProjectId] || !input?.probeTaskId) return {}
  // console.log('input.name getInputStatus', input.name,input, input.probeTaskId);
  if (props.inputStatuses[input?.probeProjectId] && props.inputStatuses[input?.probeProjectId][input?.probeTaskId]) {
    thumb.value = props.inputStatuses[input?.probeProjectId][input?.probeTaskId].thumb || {}
    thumbAll.value.input = props.inputStatuses[input?.probeProjectId][input?.probeTaskId].thumb || {}
  }
  return props.inputStatuses[input?.probeProjectId][input?.probeTaskId] || {}
})

const inputAlert = computed(() => {
  return inputStatusData.value.alarms || []
})

const bgInputStatusColor = computed(() => {
  if (!inputStatusData.value.status) return 'bg-neutral-500'
  if (inputAlert.value.length > 0) return 'bg-red-500'
  return 'bg-green-500'
})

const eventStatus = computed(() => {
  return props.event.status
})

const serverStatuses2 = computed(() => {
  return props.serverStatus
})

const eventStatusTextColorClass = computed(() => {
  return `text-${eventStatus.value}`
})

const bgStatusColor = computed(() => {
  return status => `bg-${status}`
})

const headerColumnClass = computed(() => {
  return `grid-cols-${props.visibleColumnDefs.length}`
})

const taskName = computed(() => {
  if (props.event.input && props.event.input.name) {
    return props.event.input.name.trim()
  }
  return undefined
})

const outputUI = computed(() => {
  const newItem = { ...props.event }
  newItem.outputUI = ''
  newItem.outputPDF = ''
  newItem.outputString = ''
  props.event.outputs.items
    .filter((output) => !!output)
    .forEach((el) => {
      const [outputConfig] = newItem.actions.items
        .filter((action) => action.assignedOutput && action.assignedOutput.id === el.output.id)

         // <small class="stream-key">
      //   <i class="far fa-key" /> {{target.configWowza.targets.items[0].streamKey
      //     | defaultValue('--- not set ---')}}
      // </small>
      const hasWowzaConfig = outputConfig && outputConfig.configWowza
      const autostartTitle = hasWowzaConfig && outputConfig.configWowza.autostart ? outputConfig.configWowza.autostartOffsetMin : 0
      const autostartColor = hasWowzaConfig && outputConfig.configWowza.autostart ? 'green' : 'red'
      const autostartString = `<i class="bi bly-time ${autostartColor}" title="Offset ${autostartTitle} min"></i>`
      const autostartPDFString = autostartTitle ? `[Offset ${autostartTitle} min]` : ''
      // console.log('===> ', el, newItem. outputConfig);

      const hasStreamKey = hasWowzaConfig
        && outputConfig.configWowza.targets
        && outputConfig.configWowza.targets.items
        && outputConfig.configWowza.targets.items[0]
        && outputConfig.configWowza.targets.items[0].streamKey

      const streamKeyString = hasStreamKey ? `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-green-500">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
        </svg>
      ` : `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-red-500">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
        </svg>
      `

      const urlPdf = el.output.url ? `URL: ${el.output.url}` : ''
      const statusOutput = statusByName(el.output).status
      let color = ''
      switch (statusOutput) {
        case 'Active':
          color = 'bg-green-500'
          break
        case 'NotFound':
          color = 'bg-red-500'
          break
        case 'Error':
          color = 'bg-yellow-500'
          break
        default:
          color = 'bg-transparent'
      }

      let isConnectedString = ''

      if (props.isSysAdmin && el.output.smEndpoints) {
        const t = JSON.parse(el.output.smEndpoints)
        console.log('smEndpoints xxx', t)
        // newItem.smEndpoints = smEndpoints || [];
        const ids = t.map(sm => sm.interfaceId)
        let isConnected = false
        ids.forEach(id => {
          console.log('smEndpoints xxx ::', id, props.streamManagerConnections[id], (props.streamManagerConnections && props.streamManagerConnections[id] && props.streamManagerConnections[id].outputs_connected === ''))
          if (props.streamManagerConnections && props.streamManagerConnections[id] && props.streamManagerConnections[id].outputs_connected !== '') {
            isConnectedString = '<span class="w-2 h-2 bg-green-500 inline-block"></span>'
            isConnected = true
          }
          if (props.streamManagerConnections && props.streamManagerConnections[id] && props.streamManagerConnections[id].outputs_connected === '') {
            isConnectedString = '<span class="w-2 h-2 bg-red-500 inline-block"></span>'
          }
          if (props.streamManagerConnections && !props.streamManagerConnections[id]) {
            isConnectedString = '<span class="w-2 h-2 bg-slate-500 inline-block"></span>'
          }
        })
      }

      const statusSpan = '' //`<span class="inline-block h-3 w-3 rounded-full ${color}"></span>`;
      const ottsSeverString = el.output.ottServer && el.output.ottApplication ? `<div class="show-ma relative top-0.5 ${el.output.ottServer}">(${el.output.ottServer} - ${el.output.ottApplication})</div>` : ''
      
      
      newItem.outputUI += `
          <div class="output-${el.output.status} ">
            ${el.output.displayName || el.output.name}

            <span class="output-type-tag ${(() => {
              if (el.output.outputType === 'TECHEX') {
                if (el.output.url && el.output.url.startsWith('srt')) return 'CING-SRT'
                if (el.output.url && el.output.url.startsWith('rtp')) return 'CING-RTP'
                return 'CING'
              }
              return el.output.outputType
            })()}">${(() => {
              if (el.output.outputType === 'TECHEX') {
                if (el.output.url && el.output.url.startsWith('srt')) return 'CING-SRT'
                if (el.output.url && el.output.url.startsWith('rtp')) return 'CING-RTP'
                return 'CING'
              }
              return el.output.outputType
            })()} </span>
            <span class="output-type-tag output-status-${el.output.status}">${el.output.status}</span>

            <div class="flex gap-1 items-center"> 
              ${hasWowzaConfig ? streamKeyString : ''} 
              ${hasWowzaConfig ? autostartString : ''}

              ${ottsSeverString} ${statusSpan} ${isConnectedString}
            </div>
          </div>
        `

      if (el.outputOttApplicationOverride) {
        newItem.outputUI += `<span class="show-ma" >(OTT Override: <strong>${el.outputOttApplicationOverride}</strong>)</span>
          `
      }
    })
  // if (hasRelatedEvents) newItem.outputUI += '<span class="warning">OVERLAPPING EVENTS WITH THE SAME OUTPUT</span>';
  if (newItem.outputUI === '') newItem.outputUI = 'not set'
  return newItem.outputUI
})

// Methods
const getSelectedIndex = (event) => {
  let index = -1
  if (!props.selectedEvents) return index
  props.selectedEvents.forEach((ev, i) => {
    if (event.id === ev.id) index = i
  })
  return index
}

const statusByName = (output) => {
  const status = props.serverStatus[output.name]
  if (!status) return {}
  // console.log('serverStatuses statusByName', output.name, props.serverStatus[output.name])
  return status || {}
}

const eventProblems = computed(() => {
  if (!props.isSysAdmin) return []
  const problems = []
  
  if (!props.event.actions || !props.event.actions.items || props.event.actions.items.length === 0) {
    problems.push('ACTIONS')
  }
  if (!props.event.start) {
    problems.push('DATE')
  }
  if (!props.event.input) {
    problems.push('INPUT')
  }
  if (!props.event.outputs || !props.event.outputs.items || props.event.outputs.items.length === 0) {
    problems.push('OUTPUTS')
  }
  
  if (props.event.lineupTime && props.event.startTime && moment(props.event.lineupTime).isAfter(moment(props.event.startTime))) {
    problems.push('LINEUP > START')
  }
  if (props.event.startTime && props.event.endTime && moment(props.event.startTime).isAfter(moment(props.event.endTime))) {
    problems.push('START > END')
  }

  return problems
})
</script>

<style>
.agenda-event-actions {
  display: none;
}

.agenda-event:hover .agenda-event-actions {
  display: block;
}


pre.font-sans.audio {
  font-size: 10px;
  text-overflow: ellipsis;
  max-width: 329px;
  overflow: hidden;
  margin-right: 8px;
}
</style>
